import React from 'react';
import { Flex, TextInput, Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('userManagement.role.FilterInput');
export default function FilterInput(props) {
  const {
    eventData,
    value,
    onChange,
    searchAsType = true
  } = props;
  const {
    search,
    inCustom,
    inProject,
    inImagine
  } = value;
  const onEvent = evt => {
    const data = evt.data;
    onChange({
      value: {
        search: data === 'search' ? evt.value : search,
        inCustom: data === 'inCustom' ? !inCustom : inCustom,
        inProject: data === 'inProject' ? !inProject : inProject,
        inImagine: data === 'inImagine' ? !inImagine : inImagine
      },
      data: eventData
    });
  };
  // Add icon 
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Popup, {
    title: /*#__PURE__*/React.createElement("i", {
      className: "fa fa-filter"
    }),
    attachment: "top left",
    targetAttachment: "bottom left"
  }, /*#__PURE__*/React.createElement(Popup.Item, {
    eventData: "inCustom",
    close: false,
    onClick: onEvent
  }, " ", /*#__PURE__*/React.createElement("i", {
    className: inCustom ? 'fa fa-check fa-fw' : 'fa fa-fw'
  }), t('custom')), /*#__PURE__*/React.createElement(Popup.Item, {
    eventData: "inProject",
    close: false,
    onClick: onEvent
  }, " ", /*#__PURE__*/React.createElement("i", {
    className: inProject ? 'fa fa-check fa-fw' : 'fa fa-fw'
  }), t('project')), /*#__PURE__*/React.createElement(Popup.Item, {
    eventData: "inImagine",
    close: false,
    onClick: onEvent
  }, " ", /*#__PURE__*/React.createElement("i", {
    className: inImagine ? 'fa fa-check fa-fw' : 'fa fa-fw'
  }), t('imagine'))), /*#__PURE__*/React.createElement(TextInput, {
    size: 40,
    value: search,
    eventData: "search",
    onChange: onEvent,
    changeOnReturn: !searchAsType
  }));
}